import { render } from "./candidate-setup-row.vue?vue&type=template&id=0cd153b3"
import script from "./candidate-setup-row.vue?vue&type=script&lang=js"
export * from "./candidate-setup-row.vue?vue&type=script&lang=js"

import "./candidate-setup-row.vue?vue&type=style&index=0&id=0cd153b3&lang=css"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__